(function () {
    var root = document.querySelector(".cart-screen");
    if (!root) return;

    var itemsWrap = root.querySelector("[data-cart-items]");
    var cartTotalEls = root.querySelectorAll("[data-cart-total]");
    var cartCountEls = root.querySelectorAll("[data-cart-count]");
    var checkoutButtons = root.querySelectorAll('button[name="checkout"], .cart-sticky-checkout__button');

    var stickyCheckout = root.querySelector("[data-sticky-checkout]");
    var stickySentinel = root.querySelector("[data-sticky-checkout-sentinel]");
    var isDesktopStickyActive = false;

    var pendingLineUpdates = new Set();

    document.addEventListener("DOMContentLoaded", function () {
        var cartSection = document.querySelector(".cart-screen");

        if (cartSection) {
            window.scrollTo({
                top: cartSection.offsetTop - 40,
                behavior: "instant"
            });
        }
    });

    function money(cents) {
        if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
            return window.Shopify.formatMoney(cents);
        }

        return "$" + (cents / 100).toFixed(2);
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function getItemElByLine(line) {
        return root.querySelector('[data-cart-item][data-line="' + line + '"]');
    }

    function setupStickyCheckout() {
        if (!stickyCheckout) return;

        function isMobileLayout() {
            return window.matchMedia("(max-width: 989px)").matches;
        }

        function updateStickyState() {
            if (isMobileLayout()) {
                stickyCheckout.classList.add("is-visible");
                return;
            }

            if (!stickySentinel) {
                stickyCheckout.classList.remove("is-visible");
                return;
            }

            var rect = stickySentinel.getBoundingClientRect();
            var shouldShow = rect.bottom < 0;

            stickyCheckout.classList.toggle("is-visible", shouldShow);
            isDesktopStickyActive = shouldShow;
        }

        updateStickyState();

        window.addEventListener("scroll", updateStickyState, { passive: true });
        window.addEventListener("resize", updateStickyState);
    }

    function getMaxQty(item) {
        if (item && item.quantity_rule && typeof item.quantity_rule.max === "number" && item.quantity_rule.max > 0) {
            return item.quantity_rule.max;
        }

        if (item && typeof item.inventory_quantity === "number" && item.inventory_quantity > 0) {
            return item.inventory_quantity;
        }

        if (item && item.variant && typeof item.variant.inventory_quantity === "number" && item.variant.inventory_quantity > 0) {
            return item.variant.inventory_quantity;
        }

        return null;
    }

    function renderProperties(properties) {
        if (!properties || typeof properties !== "object") return "";

        var html = Object.keys(properties)
            .filter(function (key) {
                return properties[key] != null && properties[key] !== "" && key.charAt(0) !== "_";
            })
            .map(function (key) {
                return '<div class="cart-item__property"><strong>' + escapeHtml(key) + ":</strong> " + escapeHtml(properties[key]) + "</div>";
            })
            .join("");

        if (!html) return "";
        return '<div class="cart-item__properties">' + html + "</div>";
    }

    function renderCartItems(cart) {
        if (!itemsWrap) return;

        if (!cart.items || !cart.items.length) {
            window.location.reload();
            return;
        }

        itemsWrap.innerHTML = cart.items.map(function (item, index) {
            var line = index + 1;
            var qty = parseInt(item.quantity, 10) || 0;
            var maxQty = getMaxQty(item);

            var minusDisabled = qty <= 1 ? " disabled" : "";
            var plusDisabled = (typeof maxQty === "number" && qty >= maxQty) ? " disabled" : "";
            var maxAttr = typeof maxQty === "number" ? ' data-max-qty="' + escapeHtml(maxQty) + '"' : "";

            var variantTitle = item.variant_title && item.variant_title !== "Default Title"
                ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + "</div>"
                : "";

            var imageHtml = item.featured_image && item.featured_image.url
                ? '<a href="' + escapeHtml(item.url) + '" class="cart-item__image-link"><img class="cart-item__image" src="' + escapeHtml(item.featured_image.url) + '&width=320" alt="' + escapeHtml(item.product_title || "") + '" loading="lazy"></a>'
                : '<div class="cart-item__image cart-item__image--placeholder"></div>';

            return ''
                + '<article class="cart-item" data-cart-item data-key="' + escapeHtml(item.key) + '" data-line="' + line + '"' + maxAttr + '>'
                + '  <div class="cart-item__media">' + imageHtml + '</div>'
                + '  <div class="cart-item__content">'
                + '    <div class="cart-item__top">'
                + '      <div>'
                + '        <h2 class="cart-item__title"><a href="' + escapeHtml(item.url) + '">' + escapeHtml(item.product_title) + '</a></h2>'
                +          variantTitle
                + '      </div>'
                + '      <button type="button" class="cart-item__remove" data-remove-item data-line="' + line + '" aria-label="Remove ' + escapeHtml(item.product_title || "item") + '">✕</button>'
                + '    </div>'
                + '    <div class="cart-item__bottom">'
                + '      <div class="cart-item__quantity">'
                + '        <span class="cart-item__label">Quantity</span>'
                + '        <div class="cart-qty" data-qty-wrap>'
                + '          <button type="button" class="cart-qty__button" data-qty-minus data-line="' + line + '" aria-label="Decrease quantity"' + minusDisabled + '>−</button>'
                + '          <input class="cart-qty__input" type="number" min="1" step="1" inputmode="numeric" value="' + escapeHtml(item.quantity) + '" data-qty-input data-line="' + line + '"' + (typeof maxQty === "number" ? ' max="' + escapeHtml(maxQty) + '"' : '') + ' aria-label="Quantity">'
                + '          <button type="button" class="cart-qty__button" data-qty-plus data-line="' + line + '" aria-label="Increase quantity"' + plusDisabled + '>+</button>'
                + '        </div>'
                + '      </div>'
                + '      <div class="cart-item__prices" data-line-price-wrap>'
                + '        <div class="cart-item__price-loading" data-line-loading hidden>'
                + '          <span class="cart-item__price-spinner" aria-hidden="true"></span>'
                + '        </div>'
                + '        <div class="cart-item__unit-price">' + money(item.final_price) + (item.quantity > 1 ? '<span class="cart-item__unit-price-note">each</span>' : '') + '</div>'
                + '        <div class="cart-item__line-price">' + money(item.final_line_price) + '</div>'
                + '      </div>'
                + '    </div>'
                +      renderProperties(item.properties)
                + '  </div>'
                + '</article>';
        }).join("");

        syncAllQuantityControls();
    }

    function updateSummary(cart) {
        cartTotalEls.forEach(function (el) {
            el.innerHTML = money(cart.total_price || 0);
        });

        cartCountEls.forEach(function (el) {
            el.textContent = String(cart.item_count || 0);
        });
    }

    function setCheckoutButtonState() {
        var busy = pendingLineUpdates.size > 0;

        checkoutButtons.forEach(function (button) {
            button.disabled = busy;
            button.classList.toggle("is-loading", busy);

            var text = button.querySelector(".cart-summary__checkout-button-text");
            if (text) {
                text.textContent = busy ? "Updating cart..." : "Checkout";
            }
        });
    }

    function syncLineQtyControls(line) {
        var itemEl = getItemElByLine(line);
        if (!itemEl) return;

        var minusBtn = itemEl.querySelector("[data-qty-minus]");
        var plusBtn = itemEl.querySelector("[data-qty-plus]");
        var input = itemEl.querySelector("[data-qty-input]");

        if (!input) return;

        var qty = parseInt(input.value, 10);
        if (!Number.isFinite(qty) || qty < 1) qty = 1;

        var maxQtyAttr = itemEl.getAttribute("data-max-qty");
        var maxQty = maxQtyAttr ? parseInt(maxQtyAttr, 10) : NaN;
        var isInputDisabled = !!input.disabled;

        if (minusBtn) {
            minusBtn.disabled = isInputDisabled || qty <= 1;
        }

        if (plusBtn) {
            plusBtn.disabled = isInputDisabled || (!Number.isNaN(maxQty) && qty >= maxQty);
        }
    }

    function syncAllQuantityControls() {
        var itemEls = root.querySelectorAll("[data-cart-item]");
        itemEls.forEach(function (itemEl) {
            var line = itemEl.getAttribute("data-line");
            if (line) syncLineQtyControls(line);
        });
    }

    function setLineLoading(line, loading) {
        var itemEl = getItemElByLine(line);
        if (!itemEl) return;

        var loadingEl = itemEl.querySelector("[data-line-loading]");
        var minusBtn = itemEl.querySelector("[data-qty-minus]");
        var plusBtn = itemEl.querySelector("[data-qty-plus]");
        var input = itemEl.querySelector("[data-qty-input]");
        var removeBtn = itemEl.querySelector("[data-remove-item]");

        if (loadingEl) {
            loadingEl.hidden = !loading;
        }

        if (input) input.disabled = loading;
        if (removeBtn) removeBtn.disabled = loading;

        itemEl.classList.toggle("is-updating", loading);

        if (minusBtn) minusBtn.disabled = loading || minusBtn.disabled;
        if (plusBtn) plusBtn.disabled = loading || plusBtn.disabled;

        syncLineQtyControls(line);
    }

    async function fetchCart() {
        var response = await fetch(window.Shopify.routes.root + "cart.js", {
            method: "GET",
            headers: { Accept: "application/json" }
        });

        if (!response.ok) {
            throw new Error("We could not load your cart. Please refresh and try again.");
        }

        return response.json();
    }

    async function changeLineByLine(line, quantity) {
        var payload = {
            line: Number(line),
            quantity: Number(quantity)
        };

        var response = await fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json"
            },
            body: JSON.stringify(payload)
        });

        var data = await response.json();

        if (!response.ok) {
            throw new Error(data.description || data.message || "We could not update your cart. Please try again.");
        }

        return data;
    }

    async function refreshCartUI() {
        var cart = await fetchCart();
        renderCartItems(cart);
        updateSummary(cart);
        setCheckoutButtonState();
        return cart;
    }

    async function updateQuantity(line, quantity) {
        if (pendingLineUpdates.has(line)) return;

        pendingLineUpdates.add(line);
        setLineLoading(line, true);
        setCheckoutButtonState();

        try {
            await changeLineByLine(line, quantity);
            await refreshCartUI();
        } catch (error) {
            console.error(error);
            await refreshCartUI();
        } finally {
            pendingLineUpdates.delete(line);
            setCheckoutButtonState();
        }
    }

    root.addEventListener("click", function (event) {
        var minusButton = event.target.closest("[data-qty-minus]");
        if (minusButton) {
            var lineMinus = minusButton.getAttribute("data-line");
            var inputMinus = root.querySelector('[data-qty-input][data-line="' + lineMinus + '"]');
            var currentMinus = inputMinus ? parseInt(inputMinus.value, 10) || 1 : 1;

            if (currentMinus <= 1) return;

            updateQuantity(lineMinus, currentMinus - 1);
            return;
        }

        var plusButton = event.target.closest("[data-qty-plus]");
        if (plusButton) {
            var linePlus = plusButton.getAttribute("data-line");
            var inputPlus = root.querySelector('[data-qty-input][data-line="' + linePlus + '"]');
            var currentPlus = inputPlus ? parseInt(inputPlus.value, 10) || 1 : 1;

            var itemElPlus = plusButton.closest("[data-cart-item]");
            var maxQtyPlus = itemElPlus ? parseInt(itemElPlus.getAttribute("data-max-qty"), 10) : NaN;

            if (!Number.isNaN(maxQtyPlus) && currentPlus >= maxQtyPlus) return;

            updateQuantity(linePlus, currentPlus + 1);
            return;
        }

        var removeButton = event.target.closest("[data-remove-item]");
        if (removeButton) {
            updateQuantity(removeButton.getAttribute("data-line"), 0);
            return;
        }
    });

    root.addEventListener("input", function (event) {
        var qtyInput = event.target.closest("[data-qty-input]");
        if (!qtyInput) return;

        var line = qtyInput.getAttribute("data-line");
        var next = parseInt(qtyInput.value, 10);
        var itemEl = qtyInput.closest("[data-cart-item]");
        var maxQty = itemEl ? parseInt(itemEl.getAttribute("data-max-qty"), 10) : NaN;

        if (!Number.isFinite(next) || next < 1) next = 1;
        if (!Number.isNaN(maxQty) && next > maxQty) next = maxQty;

        qtyInput.value = next;
        syncLineQtyControls(line);
    });

    root.addEventListener("change", function (event) {
        var qtyInput = event.target.closest("[data-qty-input]");
        if (!qtyInput) return;

        var line = qtyInput.getAttribute("data-line");
        var next = parseInt(qtyInput.value, 10);
        var itemEl = qtyInput.closest("[data-cart-item]");
        var maxQty = itemEl ? parseInt(itemEl.getAttribute("data-max-qty"), 10) : NaN;

        if (!Number.isFinite(next) || next < 1) next = 1;
        if (!Number.isNaN(maxQty) && next > maxQty) next = maxQty;

        qtyInput.value = next;
        syncLineQtyControls(line);
        updateQuantity(line, next);
    });

    setupStickyCheckout();

    refreshCartUI().catch(function (error) {
        console.error(error);
    });
})();